import * as _ from 'lodash'
import { showToast } from '@/util/couponCollection'
import { getDiscountGroupOrdersByGroupId } from '@/api/order'

// 获取服务合约组合订单内容
export const getContractOrderContent = async param => {
  // let discountGroupId = 'DG202207180001'
  let { discountGroupId, payAmount } = param
  let isContractOrder = Boolean(discountGroupId)
  let res = { isContractOrder, contractOrderList: [], payAmount }
  if (isContractOrder) {
    try {
      let contractOrderList = await getDiscountGroupOrdersByGroupId({ discountGroupId })
      res.contractOrderList = contractOrderList
    } catch (error) {
      showToast(error.message, '优惠组合信息加载失败')
      // res.contractOrderList = [
      //   {
      //     orderNo: 'SC202207180001',
      //     productsNames: '普通机油_原厂保养套餐_2a'
      //   },
      //   {
      //     orderNo: 'SC202207180002',
      //     productsNames: '普通机油_原厂保养套餐_2a'
      //   },
      //   {
      //     orderNo: 'SC202207180003',
      //     productsNames: '普通机油_原厂保养套餐_2a'
      //   },
      //   {
      //     orderNo: 'SC202207180004',
      //     productsNames: '普通机油_原厂保养套餐_2a'
      //   },
      //   {
      //     orderNo: 'SC202207180005',
      //     productsNames: '普通机油_原厂保养套餐_2a'
      //   },
      //   {
      //     orderNo: 'SC202207180006',
      //     productsNames: '普通机油_原厂保养套餐_2a'
      //   }
      // ]
    }
  }
  return res
}

export const checkNotifications = data => {
  let hasError = false
  let notificationsDefault = {
    day: '',
    month: '',
    year: '',
    effectiveMonth: 0,
    notificationFile: null,
    notificationName: ''
  }
  if (data.effectiveMonth == -1) {
    data.effectiveMonth = '无限'
  }
  let notifications = { ...notificationsDefault, ...data }
  if (notifications) {
    for (const key in notifications) {
      if (Object.hasOwnProperty.call(notifications, key)) {
        const element = notifications[key]
        if (element === undefined || element === '' || element === null) {
          hasError = true
          console.log('checkNotifications-false-', key, element)
          break
        }
      }
    }
  } else {
    hasError = true
  }
  if (hasError) {
    showToast('告知书参数有误，请联系工作人员')
    return
  }
  return notifications
}

export const checkEWNotifications = data => {
  let hasError = false
  const notifications = _.cloneDeep(data)

  if (notifications.maxPurchaseMile == -1) {
    _.set(notifications, 'maxPurchaseMile', '1000000')
  }
  if (notifications.validPeriod == -1 && !notifications.endDate) {
    _.set(notifications, 'endDate', -1)
  }
  if (notifications) {
    for (const key in notifications) {
      if (Object.hasOwnProperty.call(notifications, key)) {
        const element = notifications[key]
        if (element === undefined || element === '' || element === null) {
          hasError = true
          break
        }
      }
    }
  } else {
    hasError = true
  }
  if (hasError) {
    showToast('告知书参数有误，请联系工作人员')
    return
  }
  return notifications
}
